import { render, staticRenderFns } from "./CustomerDirectMessage.vue?vue&type=template&id=373bc358"
import script from "./CustomerDirectMessage.vue?vue&type=script&lang=js"
export * from "./CustomerDirectMessage.vue?vue&type=script&lang=js"
import style0 from "./CustomerDirectMessage.vue?vue&type=style&index=0&id=373bc358&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports